<div class="container">
    <div class="row">
        <div class="col-md-8 offset-md-1 text-center">
            <h2 class="py-3">
                Thank you for using Shred Nations. <br>
            </h2>
            <p class="py-2" [innerHTML]="thankMessage">
            </p>
        </div>
    </div>
</div>
